import { actions } from "2g-form";
import { createModuleReducer } from "2g-utils-redux";
import { getMondayForDate } from "2g-utils-date";

import { FORM_MODULE_KEY } from "./useSmlouvaVytvoreni";

export function onSetValue(state, action) {
  if (action.meta.moduleKey !== FORM_MODULE_KEY) {
    return state;
  }
  const { path } = action.payload;
  let fixniNaroky = state.values.fixniNaroky
    ? [...state.values.fixniNaroky]
    : [];
  const addBefore = [];
  const addAfter = [];

  if (path[0] === "platnostOd" && fixniNaroky.length) {
    const dateFrom = new Date(action.payload.value);
    const mondeyFrom = getMondayForDate(dateFrom);
    const firstItem = fixniNaroky[0].datumOd;

    if (mondeyFrom.getTime() < firstItem) {
      const weekFrom = getMondayForDate(dateFrom);

      while (weekFrom.getTime() < firstItem) {
        const weekTo = new Date(weekFrom.getTime());
        weekTo.setDate(weekFrom.getDate() + 6);

        addBefore.push({
          datumOd: weekFrom.getTime(),
          datumDo: weekTo.getTime()
        });
        weekFrom.setDate(weekFrom.getDate() + 7);
      }
    } else if (mondeyFrom.getTime() > firstItem) {
      fixniNaroky = fixniNaroky.filter(
        item => mondeyFrom.getTime() <= item.datumOd
      );
    }
  }

  if (path[0] === "platnostDo" && fixniNaroky.length) {
    const dateFrom = new Date(action.payload.value);
    const mondeyFrom = getMondayForDate(dateFrom);
    const lastItem = fixniNaroky[fixniNaroky.length - 1];

    if (mondeyFrom.getTime() > lastItem.datumOd) {
      const weekFrom = getMondayForDate(new Date(lastItem.datumOd));
      weekFrom.setDate(weekFrom.getDate() + 7);

      while (weekFrom.getTime() <= mondeyFrom.getTime()) {
        const weekTo = new Date(weekFrom.getTime());
        weekTo.setDate(weekFrom.getDate() + 6);

        addAfter.push({
          datumOd: weekFrom.getTime(),
          datumDo: weekTo.getTime()
        });
        weekFrom.setDate(weekFrom.getDate() + 7);
      }
    } else if (mondeyFrom.getTime() < lastItem.datumOd) {
      fixniNaroky = fixniNaroky.filter(
        item => item.datumOd <= mondeyFrom.getTime()
      );
    }
  }

  const newFixniNaroky = [...addBefore, ...fixniNaroky, ...addAfter];

  return newFixniNaroky.length
    ? {
        ...state,
        values: {
          ...state.values,
          fixniNaroky: newFixniNaroky
        }
      }
    : state;
}

export default createModuleReducer({
  [actions.SET_VALUE]: onSetValue
});
